// API 呼び出し失敗を表す正規化済みエラー。
// HTTP status と operation（呼び出し種別）を保持し、UI 層が表示文言を
// 「status × operation」で決められるようにする。BE の生 message は英語・内部語彙・
// 未展開プレースホルダ・typo を含みうるため、ユーザーには直接出さない方針
// （execplans/2026-06-09-api-error-catalog.md §1.0/§2.5、同 feedback-plan.md §2）。
export class ApiError extends Error {
    readonly status: number;
    readonly operation: string;
    /** BE が返した生 message。開発者向け・ログ用であり、ユーザー表示には使わない。 */
    readonly rawMessage?: string;

    constructor(status: number, operation: string, rawMessage?: string) {
        super(rawMessage ?? `API error: ${operation} (status ${status})`);
        this.name = "ApiError";
        this.status = status;
        this.operation = operation;
        this.rawMessage = rawMessage;
        // ES5 ターゲットで組み込み Error を継承した際に instanceof を効かせるための prototype 復元。
        Object.setPrototypeOf(this, ApiError.prototype);
    }
}

// response が非 2xx のとき ApiError を throw する。
// 2xx のときは body を消費せず即 return するので、呼び出し側はその後
// response.json() を読める（成功パスの後方互換を保つ）。
export const throwIfNotOk = async (
    response: Response,
    operation: string,
): Promise<void> => {
    if (response.ok) return;

    let rawMessage: string | undefined;
    try {
        const body = await response.json();
        if (body && typeof body.message === "string") {
            rawMessage = body.message;
        }
    } catch {
        // body 無し / 非 JSON は無視し、status のみで扱う。
    }
    throw new ApiError(response.status, operation, rawMessage);
};
